(() => {
  const init = () => {
    const popup = document.querySelector('[data-referral-popup]');
    if (!popup || popup.dataset.signupApiBound === 'true') return;
    popup.dataset.signupApiBound = 'true';

    const form = popup.querySelector('form');
    const successView = popup.querySelector('[data-referral-success-view]');
    const signupView = popup.querySelector('[data-referral-signup-view]');
    const codeEl = popup.querySelector('[data-welcome-code-value]');
    const codeButton = popup.querySelector('[data-copy-welcome-code]');
    const status = popup.querySelector('[data-welcome-status]');
    if (!form || !successView || !signupView || !codeEl || !codeButton || !status) return;

    const emailInput = form.querySelector('input[type="email"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const consentInput = form.querySelector('.referral-popup__consent input[type="checkbox"]');

    const ownCode = () => {
      try { return (localStorage.getItem('ellivieReferralCode') || '').trim().toUpperCase(); }
      catch (_) { return ''; }
    };
    const showError = (message) => {
      let box = form.querySelector('[data-referral-api-error]');
      if (!box) {
        box = document.createElement('div');
        box.dataset.referralApiError = '';
        box.className = 'referral-popup__message referral-popup__message--error';
        box.setAttribute('role', 'alert');
        form.prepend(box);
      }
      box.textContent = message;
    };

    const params = new URLSearchParams(window.location.search);
    const result = params.get('referral_signup');
    if (result === 'success') {
      const welcomeCode = (params.get('welcome_code') || '').trim();
      const referralCode = (params.get('referral_code') || ownCode()).trim().toUpperCase();
      try {
        localStorage.setItem('ellivieReferralSignedUp', 'true');
        if (referralCode) localStorage.setItem('ellivieReferralCode', referralCode);
        localStorage.removeItem('ellivieReferralPendingSignup');
      } catch (_) {}

      signupView.setAttribute('hidden', '');
      successView.removeAttribute('hidden');
      popup.hidden = false;
      popup.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';

      if (welcomeCode) {
        codeEl.textContent = welcomeCode;
        codeButton.disabled = false;
        codeButton.dataset.code = welcomeCode;
        status.textContent = 'Din personliga kod är aktiverad och kan användas en gång.';
      }

      ['referral_signup','welcome_code','referral_code','referral_error'].forEach(key => params.delete(key));
      const clean = `${location.pathname}${params.toString() ? `?${params}` : ''}${location.hash}`;
      history.replaceState(history.state, '', clean);
      return;
    }

    if (result === 'error') {
      const message = params.get('referral_error') || 'Registreringen kunde inte slutföras just nu.';
      showError(message);
      popup.hidden = false;
      popup.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      ['referral_signup','referral_error'].forEach(key => params.delete(key));
      const clean = `${location.pathname}${params.toString() ? `?${params}` : ''}${location.hash}`;
      history.replaceState(history.state, '', clean);
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const email = (emailInput?.value || '').trim();
      if (!emailInput?.checkValidity()) {
        emailInput?.reportValidity();
        return;
      }
      if (consentInput && !consentInput.checked) {
        consentInput.reportValidity();
        return;
      }

      const code = ownCode();
      if (!code) {
        showError('Registreringskoden saknas. Ladda om sidan och försök igen.');
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Registrerar…';
      }

      try {
        localStorage.setItem('ellivieReferralPendingSignup', 'true');
      } catch (_) {}

      const postForm = document.createElement('form');
      postForm.method = 'POST';
      postForm.action = 'https://studio.elliviehome.com/api/referral-signup';
      postForm.style.display = 'none';

      const add = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value || '';
        postForm.appendChild(input);
      };

      add('mode', 'navigate');
      add('email', email);
      add('ownCode', code);
      add('returnTo', window.location.href);
      document.body.appendChild(postForm);
      postForm.submit();
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
